// Adding constant Languages here for now
// Later it will be stored at backend
export const Languages = [
    {
        key: 'en',
        name: 'English',
        localizedName: 'English',
    },
    {
        key: 'zh',
        localizedName: '简体中文',
        name: 'Chinese (Simplified)',
    },
    {
        key: 'fr',
        localizedName: 'Français',
        name: 'French',
    },
    {
        key: 'de',
        localizedName: 'Deutsch',
        name: 'German',
    },
    {
        key: 'ja',
        localizedName: '日本語',
        name: 'Japanese',
    },
    {
        key: 'ko',
        localizedName: '한국어',
        name: 'Korean',
    },
    {
        key: 'mn',
        localizedName: 'монгол',
        name: 'Mongolian',
    },
    {
        key: 'no',
        localizedName: 'Norsk',
        name: 'Norwegian',
    },
    {
        key: 'pl',
        localizedName: 'Polski',
        name: 'Polish',
    },
    {
        key: 'pt',
        localizedName: 'Português',
        name: 'Portuguese',
    },
    {
        key: 'es',
        localizedName: 'Español',
        name: 'Spanish',
    },
    {
        key: 'tr',
        localizedName: 'Türk',
        name: 'Turkish',
    },
];

export const Whitelist = Languages?.map((lang) => lang.key);

export const getLanguageByKey = (key) => {
    return Languages.find((lang) => lang.key === key);
};
